import { render } from "./OverloadedGenresTab.vue?vue&type=template&id=31420381&scoped=true"
import script from "./OverloadedGenresTab.vue?vue&type=script&lang=js"
export * from "./OverloadedGenresTab.vue?vue&type=script&lang=js"

import "./OverloadedGenresTab.vue?vue&type=style&index=0&id=31420381&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31420381"

export default script